import {ContactView} from "../../../types/Contact";
import {Button, Container, Modal} from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {DateUtilCs} from "zavadil-ts-common";

export type ContactDetailProps = {
	contact: ContactView;
	onClosed: () => void;
}

export default function ContactDetail({contact, onClosed}: ContactDetailProps) {

	const rowClass = 'my-2';
	const col1 = 3;

	return (
		<Modal size="lg" show={true} onHide={onClosed}>
			<Modal.Header closeButton>
				<Modal.Title>{contact.name}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Container>
					<Row className={`small ${rowClass}`}>
						<Col sm={col1}>Naposledy aktualizováno:</Col>
						<Col>{DateUtilCs.formatDateTimeForHumans(contact.lastUpdate)}</Col>
					</Row>
					<Row className={`small ${rowClass}`}>
						<Col sm={col1}>Scraping selhal:</Col>
						<Col>{contact.notFoundCounter} krát</Col>
					</Row>
					<Row className={`small ${rowClass}`}>
						<Col sm={col1}>Scraping URL:</Col>
						<Col>
							<a href={contact.scrapingUrl} target="_blank">
								{contact.scrapingUrl}
							</a>
						</Col>
					</Row>
					<Row className={rowClass}>
						<Col md={col1}>Zdroj dat:</Col>
						<Col>
							<strong>{contact.sourceName}</strong>
						</Col>
					</Row>
					<Row className={rowClass}>
						<Col md={col1}>Druh pomoci:</Col>
						<Col>
							<strong>{contact.typeName}</strong>
						</Col>
					</Row>
					<Row className={rowClass}>
						<Col md={col1}>Region:</Col>
						<Col>
							<strong>{contact.regionName}</strong>
						</Col>
					</Row>
					<Row className={rowClass}>
						<Col md={col1}>Cílové skupiny:</Col>
						<Col>
							<ul className="pl-3">
								{contact.targetGroups.map(group => (
									<li key={group.id}>{group.name}</li>
								))}
							</ul>
						</Col>
					</Row>
					<Row className={rowClass}>
						<Col md={col1}>Věkové skupiny:</Col>
						<Col>
							<ul className="pl-3">
								{contact.ageGroups.map(group => (
									<li key={group.id}>{group.name}</li>
								))}
							</ul>
						</Col>
					</Row>
					<Row className={rowClass}>
						<Col md={col1}>Kontaktní údaje:</Col>
						<Col>
							<table className="table table-striped table-sm border round">
								<tbody>
								{contact.items.map(item => (
									<tr key={item.id}>
										<td>{item.name}</td>
										<td>{item.description}</td>
										<td>{item.data}</td>
									</tr>
								))}
								</tbody>
							</table>
						</Col>
					</Row>
				</Container>

				<div className="mt-2 text-center">
					<Button
						variant="secondary"
						onClick={onClosed}
						className="mr-2"
					>Zavřít</Button>
				</div>
			</Modal.Body>
		</Modal>
	);
}
